function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_33",
  "data-name": "Layer 33"
}, React.createElement("path", {
  d: "m27 5.06-7.8 11.82a1 1 0 0 0 -.16.55v8.13a3 3 0 0 1 -.88 2.12l-1.78 1.78a2 2 0 0 1 -1.42.59 1.89 1.89 0 0 1 -.76-.16 2 2 0 0 1 -1.2-1.84v-10.62a1 1 0 0 0 -.16-.55l-7.84-11.82a2 2 0 0 1 1.65-3.06h18.7a2 2 0 0 1 1.65 3.06z"
}));

var SvgFilterFill = function SvgFilterFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFilterFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-fill.2f89101c.svg";
export { ForwardRef as ReactComponent };